const youtubeRegex = new RegExp('^(http(s)?:\\/\\/)?((w){3}.)?youtu(be|.be)?(\\.com)?\\/.+');

export default link => youtubeRegex.test(link);
